import React from 'react';

import CFooterComponent from '../openWidgetComponent/cFooterComponent';
import MentorAvailabilityStatusBeacon from './mentorAvailabilityStatusBeacon';

import userDefaultImage from '../../../assets/svg/user-default-icon.svg';

import './multiExpertWidgetAccountRow.css';

const MultiExpertWidgetAccountRow = ({
  isDemo = false,
  showMentorAvailabilityStatus = true,
  extendedMentorDto = {},
  peerAvailability = null,
  profileImage = null,
  onFooterOptionSelected = () => {},
  openWidget = () => {},
}) => {
  return (
    <div
      className="et-multi-expert-widget-account-row-container"
      onClick={openWidget}>
      <div className="et-mewar-footer-wrap">
        <CFooterComponent
          disableIconsAnim
          hideFooterTabText
          isDemo={isDemo}
          isInAgentList
          mentor={extendedMentorDto}
          onFooterOptionSelected={onFooterOptionSelected}
        />
      </div>
      <div className="et-mewar-beacon-photo-name-title-wrap">
        <div className="et-mewar-beacon-photo-wrap">
          {showMentorAvailabilityStatus && (
            <MentorAvailabilityStatusBeacon
              availabilityStatus={peerAvailability}
            />
          )}
          <img
            className={
              profileImage ? 'et-mewar-photo' : 'et-mewar-photo-default'
            }
            src={profileImage ?? userDefaultImage}
            alt=""
          />
        </div>
        <div className="et-mewar-name-title-wrap">
          <div className="et-mewar-name">
            {extendedMentorDto.mentorDto.displayName}
          </div>
          {extendedMentorDto.sessionTemplateDto?.sessionTitle && (
            <div className="et-mewar-title">
              {extendedMentorDto.sessionTemplateDto.sessionTitle}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiExpertWidgetAccountRow;
